export enum DbResetType {
    None = 0,
    Daily = 1,
    BiWeekly = 2,
    Weekly = 3,
    Monthly = 4,
    Never = 5,
    Custom = 100,
}
